import { lazy } from 'react';

const FLAG = 'bsr:stale-chunk-reload';

export function isChunkLoadError(error) {
  const msg = String(error?.message || error || '');
  return (
    /Failed to fetch dynamically imported module/i.test(msg) ||
    /Importing a module script failed/i.test(msg) ||
    /error loading dynamically imported module/i.test(msg) ||
    error?.name === 'ChunkLoadError'
  );
}

/** Clear after a successful boot so a later deploy can still trigger one reload. */
export function clearStaleChunkReloadFlag() {
  try {
    sessionStorage.removeItem(FLAG);
  } catch {
    /* ignore */
  }
}

/** @returns {boolean} true if a reload was scheduled */
export function reloadOnceForStaleChunk() {
  try {
    if (sessionStorage.getItem(FLAG) === '1') {
      sessionStorage.removeItem(FLAG);
      return false;
    }
    sessionStorage.setItem(FLAG, '1');
  } catch {
    /* ponytail: no storage → still reload once; loop risk only if chunk stays 404 forever */
  }
  window.location.reload();
  return true;
}

export function installVitePreloadErrorHandler() {
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    reloadOnceForStaleChunk();
  });
}

/** React.lazy that reloads once on stale hashed chunks after deploy. */
export function lazyRetry(factory) {
  return lazy(() =>
    factory().catch((error) => {
      if (isChunkLoadError(error) && reloadOnceForStaleChunk()) {
        return new Promise(() => {});
      }
      throw error;
    }),
  );
}
